const defualtTheme = {
  overrides: {
    MuiInputBase: {
      input: {
        backgroundColor: 'white',
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 14,
      },
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: 'black',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#eac13e',
    },
    secondary: {
      main: '#ef6c00',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 796,
      md: false,
      lg: false,
      xl: false,
    },
  },
};

export default defualtTheme;
